/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Nav_MulaiInputs */

const en_simple_nav_mulai = /** @type {(inputs: Simple_Nav_MulaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a programmer`)
};

const id_simple_nav_mulai = /** @type {(inputs: Simple_Nav_MulaiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan programmer`)
};

/**
* | output |
* | --- |
* | "Not a programmer" |
*
* @param {Simple_Nav_MulaiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_nav_mulai = /** @type {((inputs?: Simple_Nav_MulaiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Nav_MulaiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_nav_mulai(inputs)
	return en_simple_nav_mulai(inputs)
});